import React from 'react';
import { useNavigation } from 'react-navi';
import { SettingsStore, ConfigStore, NamingJsonStore, ZenJsUtils } from '@zen/common-app-parts';
import { notification } from '@zen-common/components-base';
import { truncateOrNameAsset } from '@zen/common-utils/lib/utils/assetUtils';
import {
  CancelStore,
  IssueStore,
  RedeemStore,
  VerifyEventStore,
  VerifyAssetStore,
} from '../../stores/FixedPayoutStore';
import PATHS from '../../paths';
import useContract from '../../hooks/useContract';

export const useOracleConnectivitySetting = () => {
  const { state, actions } = SettingsStore.useStore();
  const config = ConfigStore.useStore();
  const navigation = useNavigation();

  const {
    actions: { reset: resetIssueStore },
  } = IssueStore.useStore();
  const {
    actions: { reset: resetCancelStore },
  } = CancelStore.useStore();
  const {
    actions: { reset: resetRedeemStore },
  } = RedeemStore.useStore();
  const {
    actions: { reset: resetVerifyAssetStore },
  } = VerifyAssetStore.useStore();
  const {
    actions: { reset: resetVerifyEventStore },
  } = VerifyEventStore.useStore();

  const handleAction = async (action) => {
    const [chain, nodeUrl] = action.value.split(' ');
    actions.setSetting({ name: 'nodeUrl', value: nodeUrl });
    actions.setSetting({ name: 'chain', value: chain });
    //Resets FP stores
    resetIssueStore();
    resetCancelStore();
    resetRedeemStore();
    resetVerifyAssetStore();
    resetVerifyEventStore();

    const chainName = chain === 'main' ? 'Mainnet' : 'Testnet';
    // navigate only after next render, all values need to be updated first
    setTimeout(() => {
      notification(
        <>
          Chain successfully switched,
          <br />
          you are currently running on {chainName}
        </>,
        { type: notification.TYPE.SUCCESS }
      );
      navigation.navigate(PATHS.CHAIN_SWITCHED);
    }, 0);
  };

  return {
    value: `${state.settings.chain} ${state.settings.nodeUrl}`,
    items: config.nodes,
    onAction: handleAction,
  };
};

export const useVersionsSetting = () => {
  const {
    state: {
      settings: { chain },
    },
  } = SettingsStore.useStore();
  const { state: naming } = NamingJsonStore.useStore();
  const {
    id,
    actions: { setId },
  } = useContract();
  const config = ConfigStore.useStore();
  const handleAction = async (action) => {
    setId(action.value);
    // navigate only after next render, all values need to be updated first
    setTimeout(() => {
      notification(
        <>
          Contract version successfully switched,
          <br />
          you are currently running{' '}
          {!!naming && naming[action.value]
            ? `${naming[action.value].name} - ${truncateOrNameAsset(
                ZenJsUtils.getContractAddress(chain, action.value)
              )}`
            : truncateOrNameAsset(ZenJsUtils.getContractAddress(chain, action.value))}
        </>,

        { type: notification.TYPE.SUCCESS }
      );
    }, 0);
  };
  const items = (config.contracts || []).map((item) => ({
    label:
      !!naming && naming[item]
        ? `${naming[item].name} - ${truncateOrNameAsset(
            ZenJsUtils.getContractAddress(chain, item)
          )}`
        : truncateOrNameAsset(ZenJsUtils.getContractAddress(chain, item)),
    value: item,
  }));

  return {
    value: id,
    items,
    naming,
    chain,
    onAction: handleAction,
  };
};
